import Response from '../base/Response';

export default class SuccessResponse extends Response {

}
